import React, {ReactNode} from 'react'
import {AdminDefaultButton} from '../../../styledComponents/adminPage/Buttons'
import {DeleteLink} from '../../../styledComponents/adminPage/Links'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import EventEmitterExAdmin from '../../shared/pageBaseComponents/EventEmitterExAdmin'
import PPTextField from '../../shared/forms/PPTextField'
import PPErrorDisplaySpan from '../../shared/forms/PPErrorDisplaySpan'
import styled from 'styled-components'
import {Box} from '@mui/material'
import {Colors} from '../../../styledComponents/Constants'

interface Props {
    gateNumbers: string[]
    eventEmitter: EventEmitterExAdmin
    onChange: (gateNumbers: string[]) => void
}

interface State {
    inputValue: string
}

export default class GateNumbersForm extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)

        this.handleChangeGateNumber = this.handleChangeGateNumber.bind(this)
        this.handleAddClick = this.handleAddClick.bind(this)

        this.state = {inputValue: ''}
    }

    handleChangeGateNumber(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({inputValue: event.target.value})
    }

    handleAddClick(): void {
        const {gateNumbers} = this.props
        this.props.onChange([...gateNumbers, this.state.inputValue])
        this.setState({inputValue: ''})
    }

    handleDeleteClick = (value: number) => (_: React.MouseEvent<HTMLElement>) => {
        const gateNumbers = [...this.props.gateNumbers]
        gateNumbers.splice(value, 1)
        this.props.onChange(gateNumbers)
    }

    renderGateNumbersTable(gateNumbers: string[]): ReactNode {
        if (gateNumbers.length === 0) {
            return null
        }

        return gateNumbers.map((gateNumber, index) => (
            <LeftRowFlexContainer key={index}>
                <GateNumberItem>
                    <GateNumberText>
                        {gateNumber}
                    </GateNumberText>
                    <DeleteLink
                        onClick={this.handleDeleteClick(index)}
                    >
                        削除
                    </DeleteLink>
                </GateNumberItem>
                <PPErrorDisplaySpan
                    eventEmitter={this.props.eventEmitter}
                    eventKeys={[`gateNumbers[${index}]`]}
                />
            </LeftRowFlexContainer>
        ))
    }

    render(): ReactNode {
        const {gateNumbers} = this.props

        return <>
            <GateNumberInputLabel>
                <div>ゲート番号</div>
                <Box width={'20px'}/>
                <GateNumberInput
                    inputProps={{
                        maxLength: 2,
                    }}
                    onChange={this.handleChangeGateNumber}
                    eventEmitter={this.props.eventEmitter}
                    eventKeys={['gateNumbers']}
                    value={this.state.inputValue}
                />
                <Box width={'20px'}/>
                <AdminDefaultButton
                    size={'small'}
                    disabled={this.state.inputValue === ''}
                    onClick={this.handleAddClick}
                >
                    追加
                </AdminDefaultButton>
            </GateNumberInputLabel>
            {this.renderGateNumbersTable(gateNumbers)}
        </>
    }
}

const GateNumberInputLabel = styled.label`
  display: flex;
  align-items: center;
`

const GateNumberInput = styled(PPTextField)`
  width: 60px;
`

const GateNumberText = styled.div`
  width: 60px;
`

const GateNumberItem = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${Colors.AccentLight};
  padding: 8px;
  margin: 0 15px;
`
